import React, { useState } from "react";
import { toast } from "sonner";
import { api, fmtError } from "@/lib/api";
import { PublicHeader } from "@/components/layout/Layout";

export default function ForgotPassword() {
  const [email, setEmail] = useState(""); const [busy, setBusy] = useState(false); const [ok, setOk] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setOk(true); }
    catch (err) { toast.error(fmtError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-white">
      <PublicHeader />
      <div className="max-w-md mx-auto px-4 py-10">
        <h1 className="text-2xl font-semibold text-[#1F2933]">Mot de passe oublié</h1>
        {ok ? (
          <p className="mt-4 text-sm text-[#1F2933]" data-testid="forgot-success">
            Si un compte existe pour cette adresse, un e-mail vient d'être envoyé.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="label">Adresse e-mail</label>
              <input required type="email" className="input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            <button disabled={busy} className="btn-primary w-full" data-testid="forgot-submit">Envoyer le lien</button>
          </form>
        )}
      </div>
    </div>
  );
}
